// src/services/analyticsService.ts

import { BASE_URL } from "../utils/config";

export function captureEvent(
	event: string,
	properties: Record<string, unknown> = {},
	beacon = false,
): void {
	try {
		window.posthog?.capture?.(
			event,
			{ path: window.location.pathname, ...properties },
			beacon ? { send_instantly: true, transport: "sendBeacon" } : undefined,
		);
	} catch (error) {
		console.warn(`Failed to capture ${event} event:`, error);
	}
}

export async function sendEvent(label: string, data: any): Promise<void> {
	try {
		await fetch(`${BASE_URL}/events`, {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ label, data }),
		});
	} catch (error) {
		console.error("Failed to send event:", error);
	}
}

/**
 * Fires a PostHog `voucher_claimed` event immediately before the page
 * reload that follows every voucher claim.
 *
 * Uses `send_instantly: true` (skip the batched queue) plus the `sendBeacon`
 * transport. `navigator.sendBeacon` is the W3C API designed for firing
 * requests during page unload — the browser guarantees delivery even though
 * we cannot await its completion before redirecting.
 *
 * Both options are documented in `@posthog/types` `CaptureOptions`:
 *   send_instantly?: boolean
 *   transport?: 'XHR' | 'fetch' | 'sendBeacon'
 *
 * @param code The voucher code that was claimed (stored as the `code`
 *             event property so sessions can be filtered by voucher in
 *             PostHog for diagnosis).
 */
export function trackVoucherClaimed(code: string): void {
	try {
		window.posthog?.capture?.(
			"voucher_claimed",
			{ code },
			{ send_instantly: true, transport: "sendBeacon" },
		);
	} catch (error) {
		console.warn("Failed to capture voucher_claimed event:", error);
	}
}
